/**
 * @generated SignedSource<<c38eb16216d522e33029a04ae0bef849>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ImagePublic_image$data = {
  readonly publicImageUrl: string;
  readonly " $fragmentType": "ImagePublic_image";
};
export type ImagePublic_image$key = {
  readonly " $data"?: ImagePublic_image$data;
  readonly " $fragmentSpreads": FragmentRefs<"ImagePublic_image">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ImagePublic_image",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publicImageUrl",
      "storageKey": null
    }
  ],
  "type": "PublicImage",
  "abstractKey": null
};

(node as any).hash = "24eca7078af856934317f346c48577cf";

export default node;
